import { buildRoutes } from "@app/routes/RouteBuilder";
import lazyWithRetry from "@shared/utils/lazyWithRetry";

const GestionCatalogos = lazyWithRetry(
  () => import("./ui/GestionCatalogos"),
  "GestionCatalogos",
);

const catalogosRoutes = buildRoutes([
  {
    path: "/catalogos",
    element: GestionCatalogos,
    roles: [1, 5], // Admin y Developer
  },
]);

export default catalogosRoutes;
